import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import './spinner.css';
import './tachyons.css';
import Routes from './Routes';

ReactDOM.render(
  <React.StrictMode>
    <Routes />
  </React.StrictMode>,
  document.getElementById('root')
);
